import _ from 'lodash';

import { SegmentFragment, useGetAudienceSegmentsQuery } from '@occc/graphql';

type UseGetAudienceSegmentsParams = {
  chainIdEquals?: string;
  segmentUuids: string[];
};

export type UseGetAudienceSegmentsReturns = {
  segments: SegmentFragment[];
  loading: boolean;
};

export const useGetAudienceSegments = ({
  chainIdEquals,
  segmentUuids,
}: UseGetAudienceSegmentsParams): UseGetAudienceSegmentsReturns => {
  const shouldLoadSegments = Boolean(segmentUuids.length);
  const { data: audienceSegmentsData, loading } = useGetAudienceSegmentsQuery({
    fetchPolicy: 'cache-and-network',
    skip: !shouldLoadSegments,
    variables: {
      filter: {
        idContains: segmentUuids || [],
        ...(chainIdEquals ? { chainIdEquals } : {}),
        isDeleted: false,
      },
    },
  });

  const segments = audienceSegmentsData?.segments
    ? _.map(audienceSegmentsData.segments.edges, 'node')
    : [];

  return {
    segments,
    loading,
  };
};
